// @flow

import type { Action } from 'app/common/redux/types';
import type { ImageDimensionsInfo } from 'app/common/redux/actions/nuxSelectedInterestImages';

export type State = {
  images: ?Array<ImageDimensionsInfo>,
};

const initialState = {
  images: [],
};

const nuxSelectedInterestImages = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'SET_NUX_SELECTED_INTEREST_IMAGES':
      return {
        ...state,
        images: action.payload.images,
      };
    default:
      return state;
  }
};

export default nuxSelectedInterestImages;
